import Main from "./Main";

import Button from "components/Button";
import ButtonIcon from "components/ButtonIcon";
import CheckBox from "components/CheckBox";
import Search from "components/Search";
import Input from "components/Input";
import SumInput from "components/SumInput";
import Select from "components/Select";
import TextArea from "components/TextArea";
import TextOval from "components/TextOval";
import InputRange from "components/InputRangeN";
import ToggleSwitch from "components/ToggleSwitch";
import SelectDoctor from "components/SelectDoctor";
import SelectDateCalendar from "components/SelectDateCalendar";
import ToggleButtons from "components/ToggleButtons";
import SelectVisit from "components/SelectVisit";
import SelectReference from "components/SelectReference";

import { ReactComponent as ArrowLeftXLIcon } from 'icons/components/arrowLeftXL.svg';
import InputTooltip from "components/InputTooltip";
import InputDate from "components/InputDate";

export default class DialogPopupAbstract extends Main {

    setPopupBackTitle(text, cb) {
        this.dialogTitle = (
            <div className="hand flex gap16 centerV" onClick={cb}>
                <ArrowLeftXLIcon />
                <div>{this.tr(text)}</div>
            </div>
        );
    }

    setDialogBackTitle(text, cb) {
        this.dialogTitle = (
            <div className="hand flex gap8 centerV" onClick={cb}>
                <ArrowLeftXLIcon width={16} height={16} />
                <div>{this.tr(text)}</div>
            </div>
        );
    }

    async getClientVisists(id, filterCanceled, filterFuture) {
        this._helper.showLoading();
        const resp = await this._request.visits.getForPlanClient(id, filterCanceled, filterFuture);
        this._helper.hideLoading();

        return resp?.data || [];
    }

    async getClientVisistsAll(id, filterCanceled) {
        this._helper.showLoading();
        const resp = await this._request.visits.getForClient(id, "endDate", false, ["WI_CREATED", "WI_COMPLETED"]);
        this._helper.hideLoading();

        return resp?.data || [];
    }

    insertSearch(props) {
        return <Search {...props} />;
    }

    insertInput(props) {
        return <Input {...props} />;
    }

    insertInputDate(props) {
        return <InputDate {...props} />;
    }

    insertInputTooltip(props) {
        return <InputTooltip {...props} />;
    }

    insertSumInput(props) {
        return <SumInput {...props} />;
    }

    insertInputRange(props) {
        return <InputRange {...props} />;
    }

    insertTextarea(props) {
        return <TextArea {...props} />;
    }

    insertSelect(props) {
        return <Select {...props} />;
    }

    insertOvalText(props) {
        return <TextOval {...props} />;
    }

    insertToggleSwitch(props) {
        return <ToggleSwitch {...props} />;
    }

    insertButtonIcon(props) {
        return <ButtonIcon {...props} />;
    }

    insertButton(props) {
        return <Button {...props} />;
    }

    insertCheckBox(props) {
        return <CheckBox {...props} />;
    }

    insertSelectDoctor(props) {
        return <SelectDoctor {...props} />;
    }

    insertSelectVisit(props) {
        return <SelectVisit {...props} />;
    }

    insertSelectDate(props) {
        return <SelectDateCalendar {...props} />;
    }

    insertSelectReference(props) {
        return <SelectReference {...props} />;
    }

    insertToggleButtons(props) {
        return <ToggleButtons {...props} />;
    }

    showError(text, label) {
        this._helper.showNotifyPopup({
            type: "error",
            label: this.tr(label || "server.error"),
            text: this.tr(text),
        });
    }

    showNotify(text, label) {
        this._helper.showNotifyPopup({
            type: "success",
            label: this.tr(label),
            text: this.tr(text),
        });
    }

    renderRow(title, component, color, key) {
        const props = {};
        if (key !== undefined)
            props.key = "Row" + key;

        return (
            <div className="detailRow flex text p1 gap8" {...props}>
                <div className="rowTitle">{this.tr(title)}</div>
                <div className={`rowValue ${color ? "compColor" + color : ""} flex1`}>{component}</div>
            </div>
        );
    }
}
